const React = require('react');
const ModalWindow = require('../../../../core/modal').default;
const { sound, soundType } = require('../../../../core/sound').default;
// ============================

export default class rankingComponent extends React.Component {
    renderContents() {
        return (
            <div>
                <div>rankingComponent</div>
                <button onClick={() => {
                    sound.playSound(soundType.SE_SELECT_SYSTEM, this.props.soundEnable)
                    this.props.handleBackClick()
                }}>back</button>
            </div>
        )
    }

    render() {
        return <ModalWindow
            isModalOpen={this.props.isModalOpen}
            closeRequest={this.props.handleBackClick}
            isCloseOutOfArea={true}
            contents={this.renderContents()}
        />
    }
}